<template>
  <div class="lp-wrapper">
    <header class="pp-site-header">
      <div class="pp-container pp-header-inner">
        <a href="#" class="pp-logo" aria-label="Pixels to Players — home" @click.prevent="navigateTo('/')">
          <img src="../src/assets/HorizontalGradientLogo-17.png" alt="Pixels to Players" width="2742" height="941">
        </a>

        <nav class="pp-main-nav" :class="{ 'is-open': isNavOpen }">
          <a href="#developers" @click.prevent="goToSection('developers')">Developer</a>
          <a href="#playtesters" @click.prevent="goToSection('playtesters')">Playtester</a>
          <a href="#resources" @click.prevent="goToSection('resources')">Resources</a>
          <a href="mailto:contact@pixelstoplayers.com" @click="closeNav">Contact</a>
          <button class="pp-btn pp-btn-primary pp-nav-cta" @click="navigateTo('/login')">Join Early Access</button>
        </nav>

        <div class="pp-header-actions">
          <button class="pp-btn pp-btn-primary pp-btn-header" @click="navigateTo('/login')">Join Early Access</button>
          <button class="pp-nav-toggle" :aria-expanded="isNavOpen ? 'true' : 'false'" aria-label="Toggle navigation" @click="toggleMenu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
    </header>

    <main>

      <section class="pp-hero">
        <div class="pp-container pp-hero-inner">
          <div class="pp-hero-content">
            <h1 ref="heroHeading">manage player insights <br>until you&rsquo;re ready to launch</h1>
            <p class="pp-hero-sub">research tools for game developers <br>now in closed BETA</p>
            <button class="pp-btn pp-btn-primary pp-btn-lg" @click="navigateTo('/login')">Join Early Access</button>

            <ul class="pp-checklist">
              <li>
                <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="none" stroke="#5226DF" stroke-width="1.6"/><path d="M6 10.2l2.6 2.6L14 7.4" fill="none" stroke="#5226DF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Collect gameplay data
              </li>
              <li>
                <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="none" stroke="#5226DF" stroke-width="1.6"/><path d="M6 10.2l2.6 2.6L14 7.4" fill="none" stroke="#5226DF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Understand your players
              </li>
              <li>
                <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="none" stroke="#5226DF" stroke-width="1.6"/><path d="M6 10.2l2.6 2.6L14 7.4" fill="none" stroke="#5226DF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Build better games
              </li>
            </ul>
          </div>

          <div class="pp-hero-image">
            <img src="../LandingPageTemp/Assets/hero-dashboard.png" alt="Pixels to Players dashboard showing screen recording review, session notes, achievements, and survey results" width="756" height="491">
          </div>
        </div>
      </section>

      <section class="pp-split-section">
        <div class="pp-split-col pp-split-dev" id="developers">
          <span class="pp-dev-pixels" aria-hidden="true">
            <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
            <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
            <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
          </span>

          <div class="pp-dev-content pp-reveal pp-reveal-left">
            <div class="pp-dev-row">
              <div class="pp-split-col-inner">
                <h2>for developers</h2>
                <p>Recruit the right players, capture gameplay, collect feedback, and turn data into decisions.</p>
                <button class="pp-btn pp-btn-white" @click="navigateTo('/login')">Explore Developer Tools</button>
              </div>

              <div class="pp-mockup-card pp-find-playtesters pp-find-playtesters-image" aria-hidden="true">
                <img src="../LandingPageTemp/Assets/find-playtesters.png" alt="Project Details screen showing Your Testers list and Find More Testers grid with Add buttons" width="512" height="300">
              </div>
            </div>

            <div class="pp-stat-cards">
              <div class="pp-mockup-card pp-progress-card">
                <p class="pp-card-title">Your Reach</p>
                <div class="pp-progress-stats-blur">
                  <span class="pp-progress-stat-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#EEEAFB"/><path d="M8 12.5l2.5 2.5L16 9.5" stroke="#5226DF" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
                  <i class="pp-blur" style="width:70px"></i>
                  <strong>128</strong>
                  <i class="pp-blur" style="width:60px"></i>
                </div>
                <div class="pp-progress-stats">
                  <div><strong>6</strong><span>Active Projects</span></div>
                  <div><strong>134</strong><span>Testers Recruited</span></div>
                </div>
              </div>
              <div class="pp-mockup-card pp-platforms-card">
                <p class="pp-card-title">Platforms Supported</p>
                <div class="pp-platform-icons">
                  <span class="pp-platform-icon" title="PC"><svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="12" rx="2" fill="none" stroke="#5226DF" stroke-width="1.5"/><path d="M8 20h8M12 16v4" stroke="#5226DF" stroke-width="1.5" stroke-linecap="round"/></svg></span>
                  <span class="pp-platform-icon" title="Console"><svg viewBox="0 0 24 24"><path d="M7 8.5h10a4.5 4.5 0 014.5 4.5v1a3 3 0 01-5.6 1.5L15 14.5H9l-.9 1a3 3 0 01-5.6-1.5v-1A4.5 4.5 0 017 8.5z" fill="none" stroke="#5226DF" stroke-width="1.5" stroke-linejoin="round"/><path d="M6.6 11v3M5.1 12.5h3" stroke="#5226DF" stroke-width="1.5" stroke-linecap="round"/><circle cx="15.6" cy="11.4" r="0.9" fill="#5226DF"/><circle cx="18" cy="13.6" r="0.9" fill="#5226DF"/></svg></span>
                  <span class="pp-platform-icon" title="Mobile"><svg viewBox="0 0 24 24"><rect x="7" y="2" width="10" height="20" rx="2" fill="none" stroke="#5226DF" stroke-width="1.5"/><path d="M11 19h2" stroke="#5226DF" stroke-width="1.5" stroke-linecap="round"/></svg></span>
                  <span class="pp-platform-icon" title="VR"><svg viewBox="0 0 24 24"><rect x="2" y="8" width="20" height="9" rx="4" fill="none" stroke="#5226DF" stroke-width="1.5"/><circle cx="8.5" cy="12.5" r="1.6" fill="none" stroke="#5226DF" stroke-width="1.4"/><circle cx="15.5" cy="12.5" r="1.6" fill="none" stroke="#5226DF" stroke-width="1.4"/><path d="M2 12.5h2M22 12.5h-2" stroke="#5226DF" stroke-width="1.4" stroke-linecap="round"/></svg></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pp-split-col pp-split-player" id="playtesters">
          <div class="pp-player-content pp-reveal pp-reveal-right">
            <div class="pp-player-row">
              <div class="pp-split-col-inner">
                <h2>for playtesters</h2>
                <p>Discover games, join playtests, play, and share feedback.</p>
                <button class="pp-btn pp-btn-primary" @click="navigateTo('/login')">Explore Player Hub</button>
              </div>

              <div class="pp-mockup-card pp-discover-games pp-discover-games-image">
                <img src="../LandingPageTemp/Assets/discover-games.png" alt="Discover projects screen showing game search, filters, and a list of playtest projects including Ghost Garden, User Test UX, Albert's Adventure, and Whack-a-corpse" width="659" height="416">
              </div>
            </div>

            <div class="pp-stat-cards">
              <div class="pp-mockup-card pp-progress-card">
                <p class="pp-card-title">Your Progress</p>
                <div class="pp-progress-stats-blur">
                  <span class="pp-progress-stat-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#EEEAFB"/><path d="M8 12.5l2.5 2.5L16 9.5" stroke="#5226DF" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
                  <i class="pp-blur" style="width:70px"></i>
                  <strong>48</strong>
                  <i class="pp-blur" style="width:60px"></i>
                </div>
                <div class="pp-progress-stats">
                  <div><strong>12</strong><span>Tests Completed</span></div>
                  <div><strong>5</strong><span>Games Played</span></div>
                </div>
              </div>
              <div class="pp-mockup-card pp-badges-card pp-badges-card-image">
                <img src="../LandingPageTemp/Assets/achievements.png" alt="Achievements screen showing badges: Login Streak, Join Games, Complete your Profile, and Submit Surveys, each with a progress bar" width="781" height="381">
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pp-provide-hiw" id="resources">
        <div class="pp-provide-block">
         <div class="pp-container">
          <h2 class="pp-section-title">what we provide</h2>

          <div class="pp-provide-grid">

            <div class="pp-provide-card pp-reveal pp-reveal-up">
              <span class="pp-provide-icon"><svg viewBox="0 0 24 24"><path d="M4 20V10M9 20V4M14 20v-7M19 20V8" stroke="#5226DF" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg></span>
              <h3>Management Hub</h3>
              <p>Organize Projects, run playtests, collect feedback, manage in app or download for your use.</p>
              <div class="pp-provide-preview pp-provide-preview-image">
                <img src="../LandingPageTemp/Assets/management-hub.png" alt="Project Details dashboard showing game information, tags, and a navigation sidebar with Dashboard, Projects, and Surveys" width="1116" height="552">
              </div>
            </div>

            <div class="pp-provide-card pp-reveal pp-reveal-up">
              <span class="pp-provide-icon"><svg viewBox="0 0 24 24"><path d="M4 8h11l-3-3M4 8l3 3M20 16H9l3 3M20 16l-3-3" stroke="#5226DF" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
              <h3>Match Playtesters</h3>
              <p>Search testers based on your requirements, assign project, gather data.</p>
              <div class="pp-provide-preview pp-provide-preview-image">
                <img src="../LandingPageTemp/Assets/match-playtesters.png" alt="Filter Testers screen with age, gender, hours, profile, platform, behaviour, and genre filters, and a grid of testers with Add buttons" width="525" height="321">
              </div>
            </div>

            <div class="pp-provide-card pp-reveal pp-reveal-up">
              <span class="pp-provide-icon"><svg viewBox="0 0 24 24"><path d="M4 8V5a1 1 0 011-1h3M20 8V5a1 1 0 00-1-1h-3M4 16v3a1 1 0 001 1h3M20 16v3a1 1 0 01-1 1h-3" stroke="#5226DF" stroke-width="1.6" fill="none" stroke-linecap="round"/><circle cx="12" cy="12" r="2.4" fill="#5226DF"/></svg></span>
              <h3>Video Tagging</h3>
              <p>Scrub instantly to player friction points with time-stamped visual telemetry.</p>
              <div class="pp-provide-preview pp-provide-preview-image">
                <img src="../LandingPageTemp/Assets/video-tagging.png" alt="Screen Recording step with a gameplay video preview and Session Notes panel for observing player behaviour" width="575" height="313">
              </div>
            </div>

            <div class="pp-provide-card pp-reveal pp-reveal-up">
              <span class="pp-provide-icon"><svg viewBox="0 0 24 24"><path d="M7 3h7l4 4v14a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="#5226DF" stroke-width="1.5" fill="none" stroke-linejoin="round"/><path d="M14 3v4h4" stroke="#5226DF" stroke-width="1.5" fill="none" stroke-linejoin="round"/><path d="M9 13h6M9 16h6M9 10h3" stroke="#5226DF" stroke-width="1.4" stroke-linecap="round"/></svg></span>
              <h3>Benchmarking</h3>
              <p>Compare player surveys and game clips to benchmark against genre baselines.</p>
              <div class="pp-provide-preview pp-provide-preview-image">
                <img src="../LandingPageTemp/Assets/benchmarking.png" alt="Project Details screen with Survey Results, first time user survey questions, and a graph of response results" width="1615" height="782">
                <span class="pp-provide-overlay">In Development</span>
              </div>
            </div>

          </div>
         </div>
        </div>

        <div class="pp-hiw-block">
         <div class="pp-container">
          <h2 class="pp-section-title">how it works</h2>

          <div class="pp-hiw-row">

            <div class="pp-hiw-step pp-reveal pp-reveal-scale">
              <span class="pp-hiw-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" fill="none" stroke="#fff" stroke-width="1.6"/><path d="M12 8.5v7M8.5 12h7" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg></span>
              <h3>1. Create Project</h3>
              <p>Set up your game and define your test goals.</p>
            </div>

            <span class="pp-hiw-connector pp-reveal pp-reveal-line" aria-hidden="true"></span>

            <div class="pp-hiw-step pp-reveal pp-reveal-scale">
              <span class="pp-hiw-icon"><svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="2.6" fill="#fff"/><path d="M4 19c0-3 2.2-5 5-5s5 2 5 5" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/><circle cx="16.5" cy="9" r="2.1" fill="none" stroke="#fff" stroke-width="1.5"/><path d="M14.5 19c.3-2.2 1.8-3.8 3.8-3.8s3.3 1.4 3.7 3.4" fill="none" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/></svg></span>
              <h3>2. Find Players</h3>
              <p>Match with the right playtesters for your game.</p>
            </div>

            <span class="pp-hiw-connector pp-reveal pp-reveal-line" aria-hidden="true"></span>

            <div class="pp-hiw-step pp-reveal pp-reveal-scale">
              <span class="pp-hiw-icon"><svg viewBox="0 0 24 24"><path d="M7 8.5h10a4.5 4.5 0 014.5 4.5v1a3 3 0 01-5.6 1.5L15 14.5H9l-.9 1a3 3 0 01-5.6-1.5v-1A4.5 4.5 0 017 8.5z" fill="none" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/><path d="M6.6 11v3M5.1 12.5h3" stroke="#fff" stroke-width="1.7" stroke-linecap="round"/><circle cx="15.6" cy="11.4" r="1" fill="#fff"/><circle cx="18" cy="13.6" r="1" fill="#fff"/></svg></span>
              <h3>3. Run Playtest</h3>
              <p>Players play your game and we capture gameplay.</p>
            </div>

            <span class="pp-hiw-connector pp-reveal pp-reveal-line" aria-hidden="true"></span>

            <div class="pp-hiw-step pp-reveal pp-reveal-scale">
              <span class="pp-hiw-icon"><svg viewBox="0 0 24 24"><path d="M4 5h16a1 1 0 011 1v9a1 1 0 01-1 1H9l-4 4v-4H4a1 1 0 01-1-1V6a1 1 0 011-1z" fill="none" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/><circle cx="8.5" cy="10.5" r="1" fill="#fff"/><circle cx="12" cy="10.5" r="1" fill="#fff"/><circle cx="15.5" cy="10.5" r="1" fill="#fff"/></svg></span>
              <h3>4. Collect Feedback</h3>
              <p>View survey results and analyze notes from gameplay.</p>
            </div>

            <span class="pp-hiw-connector pp-reveal pp-reveal-line" aria-hidden="true"></span>

            <div class="pp-hiw-step pp-reveal pp-reveal-scale">
              <span class="pp-hiw-icon"><svg viewBox="0 0 24 24"><path d="M4 20V10M9 20V4M14 20v-7M19 20V8" stroke="#fff" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg></span>
              <h3>5. Review Insights</h3>
              <p>Turn insights into better design decisions.</p>
            </div>

          </div>
         </div>
        </div>
      </section>

    </main>

    <footer class="pp-site-footer" id="contact">
      <span class="pp-footer-pixels" aria-hidden="true">
        <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
        <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
        <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
      </span>
      <div class="pp-container pp-footer-inner">
        <div class="pp-footer-visual pp-reveal pp-reveal-scale">
          <img src="../LandingPageTemp/Assets/pixels-footer-logo.png" alt="Pixels to Players" width="1689" height="1627">
        </div>
        <div class="pp-footer-content pp-reveal pp-reveal-up">
          <p class="pp-footer-eyebrow">playtest with purpose</p>
          <h2>join a community that builds better games</h2>
          <p class="pp-footer-sub">Do-it-yourself games user research. Connect with developers and players who care.</p>
          <button class="pp-btn pp-btn-white" @click="navigateTo('/login')">Join Early Access</button>
        </div>
      </div>
      <div class="pp-footer-bottom">
        <div class="pp-container">
          <p>&copy; {{ new Date().getFullYear() }} Pixels to Players. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'NewLandingPage',
  data() {
    return {
      isNavOpen: false,
    };
  },
  mounted() {
    this.setupTypewriter();
    this.setupReveal();
    this.overrideScrollbar();

    if (this.$route.hash) {
      const targetId = this.$route.hash.slice(1);
      this.$nextTick(() => {
        setTimeout(() => this.scrollToSection(targetId), 50);
      });
    }
  },
  beforeDestroy() {
    if (this._scrollbarStyleEl) this._scrollbarStyleEl.remove();
    if (this._revealObserver) this._revealObserver.disconnect();
    if (this._scheduleSweep) {
      window.removeEventListener('scroll', this._scheduleSweep);
      window.removeEventListener('resize', this._scheduleSweep);
    }
  },
  methods: {
    toggleMenu() {
      this.isNavOpen = !this.isNavOpen;
    },
    closeNav() {
      this.isNavOpen = false;
    },
    navigateTo(route) {
      this.isNavOpen = false;
      window.scrollTo(0, 0);
      this.$router.push(route);
    },
    goToSection(id) {
      this.isNavOpen = false;
      this.scrollToSection(id);
    },
    scrollToSection(id) {
      const section = document.getElementById(id);
      if (!section) return;

      const header = this.$el.querySelector('.pp-site-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const top = section.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      history.replaceState(null, '', '#' + id);
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });

      const popTargets = {
        developers: '.pp-dev-content',
        playtesters: '.pp-player-content',
      };
      const targetSelector = popTargets[id];
      if (!targetSelector) return;

      const target = section.querySelector(targetSelector) || section;
      const trigger = () => {
        target.classList.remove('pp-pop-animate');
        void target.offsetWidth;
        target.classList.add('pp-pop-animate');
      };

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        window.removeEventListener('scrollend', finish);
        trigger();
      };

      if ('onscrollend' in window) {
        window.addEventListener('scrollend', finish);
        setTimeout(finish, 900);
      } else {
        setTimeout(trigger, 650);
      }
    },
    setupTypewriter() {
      const heading = this.$refs.heroHeading;
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!heading || reduceMotion) return;

      const lines = ['manage player insights', 'until you’re ready to launch'];
      heading.textContent = '';

      const cursor = document.createElement('span');
      cursor.className = 'pp-typewriter-cursor';
      cursor.setAttribute('aria-hidden', 'true');
      heading.appendChild(cursor);

      let lineIndex = 0;
      let charIndex = 0;
      const baseSpeed = 22;

      const typeChar = () => {
        if (lineIndex >= lines.length) return;
        const currentLine = lines[lineIndex];

        if (charIndex < currentLine.length) {
          heading.insertBefore(document.createTextNode(currentLine[charIndex]), cursor);
          charIndex++;
          setTimeout(typeChar, baseSpeed + Math.random() * 16);
        } else {
          if (lineIndex < lines.length - 1) {
            heading.insertBefore(document.createTextNode(' '), cursor);
            heading.insertBefore(document.createElement('br'), cursor);
          }
          lineIndex++;
          charIndex = 0;
          setTimeout(typeChar, baseSpeed * 5);
        }
      };

      setTimeout(typeChar, 100);
    },
    overrideScrollbar() {
      const style = document.createElement('style');
      style.textContent = `
        html { scrollbar-width: none; -ms-overflow-style: none; }
        ::-webkit-scrollbar { width: 0; height: 0; }
      `;
      document.head.appendChild(style);
      this._scrollbarStyleEl = style;
    },
    setupReveal() {
      const revealEls = this.$el.querySelectorAll('.pp-reveal');
      if (!revealEls.length) return;

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealEls.forEach((el) => el.classList.add('pp-reveal-visible'));
        return;
      }

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pp-reveal-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
      revealEls.forEach((el) => io.observe(el));
      this._revealObserver = io;

      // Safety net: IntersectionObserver can miss very fast/instant scrolls
      // entirely, so force-reveal anything already at or above the fold on
      // every scroll tick, ensuring nothing is left permanently invisible.
      let sweepPending = false;
      const sweep = () => {
        sweepPending = false;
        this.$el.querySelectorAll('.pp-reveal:not(.pp-reveal-visible)').forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight) {
            el.classList.add('pp-reveal-visible');
            io.unobserve(el);
          }
        });
      };
      const scheduleSweep = () => {
        if (!sweepPending) {
          sweepPending = true;
          requestAnimationFrame(sweep);
        }
      };
      this._scheduleSweep = scheduleSweep;
      window.addEventListener('scroll', scheduleSweep, { passive: true });
      window.addEventListener('resize', scheduleSweep);
      scheduleSweep();
    },
  },
};
</script>

<style scoped>
.lp-wrapper {
  --pp-indigo: #5226DF;
  --pp-indigo-light: #6D47E6;
  --pp-indigo-dark: #3A19A6;
  --pp-orange: #FF7222;
  --pp-orange-light: #FF8E4D;
  --pp-burgundy-light: #F4BECC;

  --pp-ink: #1A1A2E;
  --pp-ink-soft: #4A4A5E;
  --pp-bg-grey: #F5F4FA;
  --pp-lavender-light: #EEEAFB;
  --pp-white: #FFFFFF;
  --pp-border-soft: #E4E1F2;

  --pp-fs-section-title: 32px;
  --pp-fs-card-title: 20px;

  --pp-card-radius: 8px;
  --pp-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  --pp-card-padding: 24px;

  --pp-container-width: 1360px;
  --pp-header-height: 76px;

  display: block;
  width: 100%;
  overflow-x: hidden;
  font-family: 'Raleway', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: var(--pp-ink);
  background: var(--pp-bg-grey);
  -webkit-font-smoothing: antialiased;
}

.lp-wrapper :where(*) { box-sizing: border-box; }

.lp-wrapper :where(img) { max-width: 100%; display: block; }

.lp-wrapper :where(a) { color: inherit; text-decoration: none; }

.lp-wrapper :where(h1, h2, h3, p, ul) { margin: 0; }

.pp-container {
  width: 100%;
  max-width: var(--pp-container-width);
  margin: 0 auto;
  padding: 0 24px;
}

/* ---------- Buttons ---------- */

.pp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
  padding: 14px 24px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}

.pp-btn:active { transform: translateY(1px); }

.pp-btn-primary {
  background: var(--pp-indigo);
  color: var(--pp-white);
}
.pp-btn-primary:hover { background: var(--pp-indigo-dark); }

.pp-btn-white {
  background: var(--pp-white);
  color: var(--pp-indigo);
}
.pp-btn-white:hover { background: var(--pp-lavender-light); }

.pp-btn-lg { padding: 16px 32px; font-size: 16px; }

.pp-btn-header { display: none; }

/* ---------- Header ---------- */

.pp-site-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: var(--pp-white);
  border-bottom: 1px solid var(--pp-border-soft);
}

.pp-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  height: 76px;
}

.pp-logo {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.pp-logo img {
  height: 48px;
  width: auto;
  display: block;
}

.pp-main-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  margin-left: auto;
}

.pp-main-nav a:not(.pp-btn) {
  font-weight: 600;
  font-size: 15px;
  color: var(--pp-ink);
}

.pp-main-nav a:not(.pp-btn):hover { color: var(--pp-indigo); }

.pp-nav-cta { margin-left: 8px; }

.pp-header-actions { display: none; align-items: center; gap: 16px; }

.pp-nav-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.pp-nav-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--pp-indigo);
  border-radius: 2px;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.pp-nav-toggle[aria-expanded="true"] span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.pp-nav-toggle[aria-expanded="true"] span:nth-child(2) { opacity: 0; }
.pp-nav-toggle[aria-expanded="true"] span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

/* ---------- Hero ---------- */

.pp-hero {
  background: var(--pp-white);
  padding: 56px 0;
  min-height: calc(100vh - var(--pp-header-height));
  display: flex;
  align-items: center;
}

.pp-hero-inner {
  display: grid;
  grid-template-columns: minmax(0, 480px) 1fr;
  gap: 40px;
  align-items: center;
}

.pp-hero-content h1 {
  font-size: clamp(30px, 3.1vw, 40px);
  font-weight: 800;
  line-height: 1.15;
  color: var(--pp-ink);
  letter-spacing: -0.01em;
  min-height: 3.6em;
}

.pp-typewriter-cursor {
  display: inline-block;
  width: 0.09em;
  height: 0.85em;
  margin-left: 0.05em;
  background: var(--pp-orange);
  vertical-align: -0.05em;
  animation: pp-caretBlink 0.85s steps(1) infinite;
}

@keyframes pp-caretBlink {
  0%, 49% { opacity: 1; }
  50%, 100% { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .pp-typewriter-cursor { animation: none; opacity: 0; }
}

.pp-hero-sub {
  margin-top: 20px;
  font-size: 18px;
  line-height: 1.5;
  color: var(--pp-ink-soft);
  animation: pp-heroFadeUp 0.5s ease-out both;
  animation-delay: 0.4s;
}

.pp-hero-content .pp-btn-lg {
  margin-top: 28px;
  animation: pp-heroBtnPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both, pp-heroBtnGlow 2.4s ease-in-out infinite;
  animation-delay: 0.15s, 0.65s;
}

.pp-checklist {
  list-style: none;
  padding: 0;
  margin: 44px 0 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.pp-checklist li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 15px;
  color: var(--pp-ink);
  animation: pp-heroSlideIn 0.5s ease-out both;
}

.pp-checklist li:nth-child(1) { animation-delay: 0.75s; }
.pp-checklist li:nth-child(2) { animation-delay: 0.92s; }
.pp-checklist li:nth-child(3) { animation-delay: 1.09s; }

.pp-checklist svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  animation: pp-heroCheckPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.pp-checklist li:nth-child(1) svg { animation-delay: 0.9s; }
.pp-checklist li:nth-child(2) svg { animation-delay: 1.07s; }
.pp-checklist li:nth-child(3) svg { animation-delay: 1.24s; }

@keyframes pp-heroFadeUp {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pp-heroSlideIn {
  from { opacity: 0; transform: translateX(-18px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes pp-heroBtnPop {
  0% { opacity: 0; transform: scale(0.7); }
  60% { opacity: 1; transform: scale(1.06); }
  100% { opacity: 1; transform: scale(1); }
}

@keyframes pp-heroCheckPop {
  0% { transform: scale(0); }
  70% { transform: scale(1.25); }
  100% { transform: scale(1); }
}

@keyframes pp-heroBtnGlow {
  0%, 100% { box-shadow: 0 4px 14px rgba(82, 38, 223, 0.22); }
  50% { box-shadow: 0 4px 22px 4px rgba(82, 38, 223, 0.4); }
}

@media (prefers-reduced-motion: reduce) {
  .pp-hero-sub,
  .pp-hero-content .pp-btn-lg,
  .pp-checklist li,
  .pp-checklist svg {
    animation: none;
  }
}

/* ---------- Hero image ---------- */

.pp-hero-image {
  width: 100%;
  animation: pp-heroImageIn 1s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: 0.2s;
}

.pp-hero-image img {
  width: 100%;
  height: auto;
  display: block;
}

@keyframes pp-heroImageIn {
  0% {
    opacity: 0;
    transform: translateY(-56px) scale(0.96);
    filter: blur(10px);
  }
  65% {
    filter: blur(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .pp-hero-image { animation: none; }
}

/* ---------- Split section (developers / playtesters) ---------- */

.pp-split-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.pp-split-col {
  padding: clamp(56px, 10vh, 110px) 28px 56px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: calc(100vh - var(--pp-header-height));
}

.pp-split-dev {
  background: linear-gradient(160deg, #5B2FE9 0%, #3A19A6 55%, #2C1180 100%);
  align-items: stretch;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
}

.pp-split-player {
  background: var(--pp-lavender-light);
  align-items: stretch;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
}

.pp-split-col-inner {
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  padding-bottom: 32px;
}

.pp-split-dev .pp-split-col-inner,
.pp-split-player .pp-split-col-inner { margin: 0; }

.pp-split-dev .pp-split-col-inner { max-width: 210px; flex-shrink: 0; }
.pp-split-player .pp-split-col-inner { max-width: 200px; flex-shrink: 0; }

.pp-player-content {
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
}

.pp-player-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;
  width: 100%;
  min-height: 266px;
}

.pp-split-player .pp-discover-games { width: 390px; max-width: 100%; flex-shrink: 0; padding: 0; }

.pp-discover-games-image {
  padding: 0;
  overflow: hidden;
  aspect-ratio: 33 / 20;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pp-discover-games-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* decorative pixel pattern, bottom-left of the developers panel */
.pp-dev-pixels {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 190px;
  height: 190px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 7px;
  padding: 18px;
  z-index: 0;
  pointer-events: none;
}
.pp-dev-pixels i { display: block; width: 100%; aspect-ratio: 1; border-radius: 3px; background: rgba(255, 255, 255, 0.07); }
.pp-dev-pixels i:nth-child(3n) { background: rgba(255, 255, 255, 0.16); }
.pp-dev-pixels i:nth-child(5n) { background: rgba(255, 142, 77, 0.14); }

.pp-dev-content {
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.pp-dev-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  min-height: 266px;
}

.pp-split-col h2 {
  font-size: var(--pp-fs-section-title);
  font-weight: 800;
  letter-spacing: -0.01em;
}

.pp-split-dev h2,
.pp-split-player h2 { font-size: 27px; }

.pp-split-dev h2 { color: var(--pp-white); }
.pp-split-player h2 { color: var(--pp-indigo); }

.pp-split-col-inner p {
  margin-top: 12px;
  font-size: 16px;
  line-height: 1.6;
  min-height: 103px;
  flex: 1;
}

.pp-split-dev .pp-split-col-inner p { color: rgba(255, 255, 255, 0.82); }
.pp-split-player .pp-split-col-inner p { color: var(--pp-ink-soft); }

.pp-split-col .pp-btn { margin-top: 24px; align-self: flex-start; }

.pp-split-dev .pp-btn-white { margin-left: -6px; }

/* Mockup cards shared */

.pp-mockup-card {
  background: var(--pp-white);
  border-radius: var(--pp-card-radius);
  box-shadow: var(--pp-card-shadow);
  padding: var(--pp-card-padding);
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}

.pp-split-dev .pp-mockup-card,
.pp-split-player .pp-mockup-card { margin: 0; }

.pp-split-dev .pp-find-playtesters { width: 390px; max-width: 100%; flex-shrink: 0; }

.pp-find-playtesters-image { padding: 0; overflow: hidden; aspect-ratio: 33 / 20; display: flex; align-items: center; justify-content: center; }
.pp-find-playtesters-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.pp-card-title {
  font-size: var(--pp-fs-card-title);
  font-weight: 700;
  color: var(--pp-ink);
  margin: 0 0 16px;
}

/* Progress / badges */

.pp-stat-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;
}

.pp-progress-stats-blur {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--pp-border-soft);
}
.pp-progress-stats-blur strong { font-size: 20px; font-weight: 800; color: var(--pp-indigo); margin-left: 10px; }
.pp-progress-stat-icon { width: 22px; height: 22px; flex-shrink: 0; }
.pp-progress-stat-icon svg { width: 100%; height: 100%; }

.pp-blur {
  display: inline-block;
  height: 10px;
  border-radius: 5px;
  background: linear-gradient(90deg, rgba(30, 20, 60, 0.5), rgba(30, 20, 60, 0.2));
  filter: blur(2px);
  flex-shrink: 0;
}

.pp-progress-stats { display: flex; gap: 28px; }
.pp-progress-stats div { display: flex; flex-direction: column; gap: 4px; }
.pp-progress-stats strong { font-size: 24px; font-weight: 800; color: var(--pp-indigo); }
.pp-progress-stats span { font-size: 12px; color: var(--pp-ink-soft); font-weight: 600; }

.pp-platform-icons { display: flex; gap: 12px; }

.pp-platform-icon {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 30%, #ffffff 0%, var(--pp-lavender-light) 55%, #e4ddf9 100%);
  box-shadow: inset 0 0 0 1px rgba(82, 38, 223, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pp-platform-icon svg { width: 20px; height: 20px; }

.pp-badges-card-image {
  padding: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.pp-badges-card-image img {
  width: 100%;
  height: auto;
  display: block;
}

/* ---------- What we provide ---------- */

.pp-provide-hiw {
  background: var(--pp-white);
  min-height: calc(100vh - var(--pp-header-height));
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pp-provide-block {
  background: var(--pp-white);
  padding: clamp(20px, 3vh, 32px) 0 clamp(16px, 2.5vh, 24px);
}

.pp-hiw-block {
  background: var(--pp-white);
  padding: clamp(16px, 2.5vh, 24px) 0 clamp(20px, 3vh, 32px);
}

.pp-section-title {
  text-align: center;
  color: var(--pp-indigo);
  font-size: clamp(22px, 2.4vw, 28px);
  font-weight: 800;
  letter-spacing: -0.01em;
  margin: 0 0 clamp(16px, 2.5vh, 28px);
}

.pp-provide-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.pp-provide-card {
  background: var(--pp-white);
  border: 1px solid var(--pp-border-soft);
  border-radius: 12px;
  box-shadow: var(--pp-card-shadow);
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.pp-provide-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--pp-lavender-light);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  flex-shrink: 0;
}
.pp-provide-icon svg { width: 18px; height: 18px; }

.pp-provide-card h3 { font-size: 14.5px; font-weight: 800; color: var(--pp-ink); margin: 0 0 6px; }
.pp-provide-card p { font-size: 12px; line-height: 1.45; color: var(--pp-ink-soft); margin: 0 0 12px; flex: 1; }

.pp-provide-preview {
  position: relative;
  border: 1px solid var(--pp-border-soft);
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 22 / 9;
  background: var(--pp-bg-grey);
}

.pp-provide-preview-image img { width: 100%; height: 100%; object-fit: cover; object-position: top; display: block; }

.pp-provide-overlay {
  position: absolute;
  inset: 0;
  background: rgba(74, 74, 94, 0.55);
  backdrop-filter: blur(1px);
  color: var(--pp-white);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 12px;
}

/* ---------- How it works ---------- */

.pp-hiw-row {
  display: flex;
  align-items: flex-start;
}

.pp-hiw-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 150px;
  flex-shrink: 0;
}

.pp-hiw-icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--pp-indigo-light), var(--pp-indigo));
  box-shadow: 0 0 0 6px rgba(82, 38, 223, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  flex-shrink: 0;
}
.pp-hiw-icon svg { width: 18px; height: 18px; }

.pp-hiw-step h3 { font-size: 13px; font-weight: 800; color: var(--pp-ink); margin: 0 0 4px; }
.pp-hiw-step p { font-size: 11.5px; line-height: 1.4; color: var(--pp-ink-soft); margin: 0; max-width: 150px; }

.pp-hiw-connector {
  flex: 1;
  min-width: 16px;
  height: 0;
  margin-top: 21px;
  border-top: 2px dashed var(--pp-border-soft);
  position: relative;
}
.pp-hiw-connector::after {
  content: '';
  position: absolute;
  right: 0;
  top: -4px;
  width: 8px;
  height: 8px;
  border-top: 2px solid var(--pp-border-soft);
  border-right: 2px solid var(--pp-border-soft);
  transform: rotate(45deg);
}

/* ---------- Scroll reveal ---------- */

.pp-reveal {
  transition: opacity 0.75s cubic-bezier(0.16, 1, 0.3, 1), transform 0.75s cubic-bezier(0.16, 1, 0.3, 1), filter 0.75s ease-out;
}

.pp-reveal:not(.pp-reveal-visible) { opacity: 0; }

.pp-reveal-left  { transform: translateX(-56px); }
.pp-reveal-right { transform: translateX(56px); }
.pp-reveal-up    { transform: translateY(36px); }
.pp-reveal-scale { transform: scale(0.85); }
.pp-reveal-line  { transform: scaleX(0); transform-origin: left center; }

.pp-reveal-visible.pp-reveal-visible {
  opacity: 1;
  transform: none;
  filter: none;
}

.pp-provide-grid .pp-provide-card:nth-child(1) { transition-delay: 0s; }
.pp-provide-grid .pp-provide-card:nth-child(2) { transition-delay: 0.1s; }
.pp-provide-grid .pp-provide-card:nth-child(3) { transition-delay: 0.2s; }
.pp-provide-grid .pp-provide-card:nth-child(4) { transition-delay: 0.3s; }

.pp-hiw-row .pp-hiw-step:nth-of-type(1) { transition-delay: 0s; }
.pp-hiw-row .pp-hiw-step:nth-of-type(2) { transition-delay: 0.12s; }
.pp-hiw-row .pp-hiw-step:nth-of-type(3) { transition-delay: 0.24s; }
.pp-hiw-row .pp-hiw-step:nth-of-type(4) { transition-delay: 0.36s; }
.pp-hiw-row .pp-hiw-step:nth-of-type(5) { transition-delay: 0.48s; }

.pp-hiw-row .pp-hiw-connector:nth-of-type(1) { transition-delay: 0.06s; }
.pp-hiw-row .pp-hiw-connector:nth-of-type(2) { transition-delay: 0.18s; }
.pp-hiw-row .pp-hiw-connector:nth-of-type(3) { transition-delay: 0.3s; }
.pp-hiw-row .pp-hiw-connector:nth-of-type(4) { transition-delay: 0.42s; }

.pp-footer-content.pp-reveal { transition-delay: 0.1s; }

@media (prefers-reduced-motion: reduce) {
  .pp-reveal { transition: none; }
}

/* ---------- Nav-jump pop animation ---------- */

@keyframes pp-sectionPop {
  0% { transform: scale(1); }
  30% { transform: scale(1.035); }
  55% { transform: scale(0.99); }
  100% { transform: scale(1); }
}

.pp-pop-animate {
  animation: pp-sectionPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) 2;
  transform-origin: center;
}

/* ---------- Footer ---------- */

.pp-site-footer {
  position: relative;
  overflow: hidden;
  background: #3A19A6;
  padding: clamp(36px, 6vh, 64px) 0;
}

.pp-footer-pixels {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 220px;
  height: 220px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  padding: 20px;
  z-index: 0;
  pointer-events: none;
}
.pp-footer-pixels i { display: block; width: 100%; aspect-ratio: 1; border-radius: 3px; background: rgba(255, 255, 255, 0.06); }
.pp-footer-pixels i:nth-child(3n) { background: rgba(255, 255, 255, 0.14); }
.pp-footer-pixels i:nth-child(5n) { background: rgba(255, 142, 77, 0.16); }

.pp-footer-inner {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 40px;
}

.pp-footer-visual {
  justify-self: start;
  width: 210px;
}
.pp-footer-visual img { width: 100%; height: auto; display: block; }

.pp-footer-content { display: flex; flex-direction: column; align-items: center; text-align: center; max-width: 780px; }

.pp-footer-eyebrow {
  color: var(--pp-orange-light);
  font-weight: 800;
  font-size: clamp(26px, 2.8vw, 36px);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin: 0 0 12px;
}

.pp-footer-content h2 {
  color: var(--pp-white);
  font-size: clamp(26px, 2.8vw, 36px);
  font-weight: 800;
  letter-spacing: -0.01em;
  margin: 0 0 14px;
}

.pp-footer-sub { color: rgba(255, 255, 255, 0.78); font-size: 15px; line-height: 1.6; max-width: 460px; margin: 0 0 16px; }

.pp-footer-bottom {
  position: relative;
  z-index: 1;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  margin-top: clamp(32px, 6vh, 56px);
}

.pp-footer-bottom p {
  text-align: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  padding: 20px 0 4px;
  margin: 0;
}

/* ==========================================================================
   Responsive
   ========================================================================== */

@media (max-width: 1024px) {
  .pp-hero-inner { grid-template-columns: minmax(0, 1fr); }
  .pp-hero-content { max-width: 560px; }
  .pp-hero-image { margin-top: 16px; }
  .pp-split-section { grid-template-columns: minmax(0, 1fr); }
  .pp-split-col { padding: 56px 32px; }
  .pp-provide-grid { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }

  .pp-hiw-row { flex-direction: column; align-items: center; gap: 28px; }
  .pp-hiw-connector { display: none; }
  .pp-hiw-step { width: 100%; max-width: 320px; }
  .pp-hiw-step p { max-width: 280px; }
}

@media (max-width: 860px) {
  .pp-main-nav {
    position: absolute;
    top: 76px;
    left: 0;
    right: 0;
    background: var(--pp-white);
    border-bottom: 1px solid var(--pp-border-soft);
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    padding: 8px 24px 20px;
    transform: translateY(-8px);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.18s ease, transform 0.18s ease;
  }

  .pp-main-nav.is-open {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: translateY(0);
  }

  .pp-main-nav a:not(.pp-btn) {
    width: 100%;
    padding: 12px 0;
    border-bottom: 1px solid var(--pp-border-soft);
  }

  .pp-nav-cta { margin: 16px 0 0; align-self: flex-start; }

  .pp-header-actions { display: flex; }
  .pp-btn-header { display: inline-flex; }
  .pp-nav-toggle { display: flex; }
}

@media (max-width: 640px) {
  .lp-wrapper {
    --pp-fs-section-title: 26px;
  }

  .pp-container { padding: 0 20px; }
  .pp-hero { padding: 40px 0 56px; }
  .pp-hero-sub br { display: none; }
  .pp-hero-content h1 br { display: none; }

  .pp-split-col { padding: 48px 20px; gap: 24px; }

  .pp-split-col-inner { padding-bottom: 0; }
  .pp-split-col-inner p { min-height: 0; flex: none; }

  .pp-dev-row { flex-direction: column; align-items: stretch; gap: 24px; min-height: 0; }
  .pp-split-dev .pp-split-col-inner { max-width: 100%; }
  .pp-split-dev .pp-find-playtesters { width: 100%; max-width: 420px; margin: 0 auto; }
  .pp-dev-pixels { width: 130px; height: 130px; opacity: 0.7; }

  .pp-player-row { flex-direction: column; align-items: stretch; gap: 24px; min-height: 0; }
  .pp-split-player .pp-split-col-inner { max-width: 100%; }
  .pp-split-player .pp-discover-games { width: 100%; max-width: 420px; margin: 0 auto; }
  .pp-stat-cards { max-width: 420px; margin: 0 auto; grid-template-columns: minmax(0, 1fr); }

  .pp-provide-grid { grid-template-columns: minmax(0, 1fr); }
  .pp-section-title { margin-bottom: 24px; }

  .pp-footer-inner { display: flex; flex-direction: column; text-align: center; gap: 20px; }
  .pp-footer-content { align-items: center; }
  .pp-footer-visual { justify-self: unset; width: 120px; }
  .pp-footer-sub { margin-left: auto; margin-right: auto; }

  .pp-btn-header { padding: 10px 16px; font-size: 14px; }
}
</style>



// WEBPACK FOOTER //
// LandingPageTemp/NewLandingPage.vue